import { createSelector } from '@ngrx/store';

import { menuFlowDefaultActivationsState } from '../root';

export const getMenuFlowDefaultActivation = (menuFlowId: number) =>
    createSelector(
        menuFlowDefaultActivationsState,
        (menuFlowDefaultActivations) => menuFlowDefaultActivations.find((obj) => obj.MenuFlowId === menuFlowId) || null
    );
